import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { currentBudgetSelector } from "../currentBudgetSelector";
import { getPlannedBudgetAmount } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/getPlannedBudgetAmount";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";

export const currentBudgetAmountSelector = createDraftSafeSelector(
  [currentBudgetSelector, organisationQuarterStartMonthSelector],
  (budget, quarterStartMonth) => {
    if (budget?.body?.type === "planned") {
      return budget?.body
        ? getPlannedBudgetAmount(
            budget.body.start_date,
            budget.body.period,
            budget.body.planned_amounts,
            quarterStartMonth,
          )
        : 0;
    }
    return budget?.body?.amount ?? 0;
  },
);
